import {Pipe, PipeTransform} from "@angular/core";
import {SimUtilityService} from "@services";

@Pipe({
	name: "stripHtml",
	standalone: true,
})
export class StripHtmlPipe implements PipeTransform {
	transform(html: string): string {
		return SimUtilityService.stripHtml(html);
	}
}
